module.exports = __webpack_public_path__ + "39985369d24b0261e70b59e524fb3ba2.pdf";